import { create } from "zustand"
import { decommissionDeviceApi } from "../services/axiosServices"

const initialPageInfo = {
  totalElements: 0,
  totalPages: 0,
  number: 0,
  size: 10,
  first: true,
  last: true,
  empty: true,
  numberOfElements: 0,
}

const initialState = {
  devices: [],
  loading: false,
  error: null,
  pageInfo: initialPageInfo,
}

export const decommissionedDeviceStore = create((set, get) => ({
  ...initialState,

  getDecommissionedDevices: async (params = {}) => {
    // Guard against duplicate in-flight requests (e.g. StrictMode double
    // effects), mirroring organizationStore's getOrganizations.
    if (get().loading) return null

    set({ loading: true, error: null })
    try {
      const res = await decommissionDeviceApi(params)
      const data = res?.data?.data

      set({
        devices: data?.content ?? [],
        pageInfo: {
          totalElements: data?.totalElements ?? 0,
          totalPages: data?.totalPages ?? 0,
          number: data?.number ?? 0,
          size: data?.size ?? params.size ?? initialPageInfo.size,
          first: data?.first ?? true,
          last: data?.last ?? true,
          empty: data?.empty ?? true,
          numberOfElements: data?.numberOfElements ?? 0,
        },
        loading: false,
      })

      return data
    } catch (err) {
      console.error("Failed to load decommissioned devices:", err)
      set({
        error: "Failed to load deleted devices. Please try again.",
        loading: false,
      })
      return null
    }
  },

  reset: () =>
    set({
      devices: [],
      loading: false,
      error: null,
      pageInfo: initialPageInfo,
    }),
}))